<div class="card mb-5">
	<div class="card-header">
		<h3>Histórico de Cierres de Cajas</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col form-group">
				<label for="startDate" class="form-label">Fecha Inicio</label>
				<input type="date" name="startDate" id="startDate" (change)="refreshTables()" [(ngModel)]="startDate" [disabled]="loadingDates"
					class="form-control">
			</div>
			<div class="col form-group">
				<label for="endDate" class="form-label">Fecha Fin</label>
				<input type="date" name="endDate" id="endDate" (change)="refreshTables()" [(ngModel)]="endDate" [disabled]="loadingDates"
					class="form-control">
			</div>
			<div class="row">
				<div class="col-12" *ngIf="loadingDates">
					<small class="text-info">
					<i class="fa fa-spinner fa-spin"></i>
					Cargando información...
					</small>
				</div>
			</div>
		</div>
		<div class="table-responsive mt-3">
			<table class="table table-bordered">
				<thead>
					<tr style="font-size: 1.1em;" class="tr-middle">
						<th>Bodega</th>
						<th>Venta</th>
						<th>Caja</th>
						<th>Depositos</th>
						<th>Cobro Tarjeta</th>
						<th>Venta al Crédito</th>
						<th>Diferencia</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let general of data; let i = index">
						<tr style="font-size: 1.1em;" class="tr-middle">
							<td>
								{{general.warehouseName}}
								<i [ngClass]="showing['w'+general.warehouse]?'fa-eye-slash':'fa-eye'"
									class="clickeable fa text-info" (click)="gettingDetailDays(general)"></i>
							</td>
							<td>{{general.sale | currency:'Q'}}</td>
							<td>{{general.cash | currency:'Q'}}</td>
							<td>{{general.transfer | currency:'Q'}}</td>
							<td>{{general.target | currency:'Q'}}</td>
							<td>{{general.credit | currency:'Q'}}</td>
							<td>{{general.difference | currency:'Q'}}</td>
						</tr>
						<tr class="tr-middle" *ngIf="showing['w'+general.warehouse] && general.days">
							<td colspan="7" style="padding: 1em; background-color: skyblue;">
								<table class="table" style="margin: 0;">
									<thead>
										<tr class="tr-middle">
											<th colspan="10" class="th-relative">
												<span class="h3"><i class="fa fa-calendar-days"></i>DÍAS</span>
												<div class="th-absolute-div">
													<i [ngClass]="general.showDays?'fa-eye-slash':'fa-eye'"
														class="fa clickeable text-info"
														(click)="general.showDays = !general.showDays"></i>
												</div>
											</th>
										</tr>
										<tr class="tr-middle" *ngIf="general.showDays">
											<th>Día</th>
											<th>Usuario</th>
											<th>Venta</th>
											<th>Caja</th>
											<th>Depositos</th>
											<th>Cobro Tarjeta</th>
											<th>Venta al Crédito</th>
											<th>Gastos</th>
											<th>Diferencia</th>
											<th></th>
										</tr>
									</thead>
									<tbody *ngIf="general.showDays">
										<ng-container *ngFor="let day of general.days; let j = index">
											<tr class="tr-middle second-table"
												[class.without-border]="showing['d' + day.id]">
												<td>
													{{day.day}}
													<i (click)="getImagesDay(day)"
														[ngClass]="showing['d' + day.id]?'fa-eye-slash':'fa-eye'"
														class="clickeable fa text-info"></i>
												</td>
												<td>
													{{day.user}}
												</td>
												<td>{{day.sale | currency:'Q'}}</td>
												<td>{{day.cash | currency:'Q'}}</td>
												<td>{{day.transfer | currency:'Q'}}</td>
												<td>{{day.target | currency:'Q'}}</td>
												<td>{{day.checkData | currency:'Q'}}</td>
												<td>{{day.expenseTotal | currency:'Q'}}</td>
												<td>{{day.difference | currency:'Q'}}</td>
												<td>
													<span class="clickeable text-danger" (click)="cashToDelete = day">
														<i class="fa fa-trash"></i>
													</span>
												</td>
											</tr>
											<tr class="tr-middle second-table"
												*ngIf="day.photos && showing['d' + day.id]">
												<td colspan="9">
													<ng-container *ngIf="day.photos.length > 0">
														<b>Fotos del cierre</b>
														<section class="scrollport">
															<div *ngFor="let photo of day.photos"
																(click)="cashImage = 'https://s3.amazonaws.com/rrhh-images/cashClosure/transferVisa/'+photo.image"
																style="background-image: url(https://s3.amazonaws.com/rrhh-images/cashClosure/transferVisa/{{photo.image}});">
																<div class="icon">
																	<i class="fa fa-eye icon"></i>
																</div>
															</div>
														</section>
													</ng-container>
													<ng-container *ngIf="day.photos.length == 0">
														<span class="display-5"><i class="fa fa-circle-info"></i> No se
															adjuntaron imagenes</span>
													</ng-container>
												</td>
											</tr>
											<!-- <tr class="tr-middle second-table"
												*ngIf="showing[general.generalDetail['id']] && showing[day['id']]">
												<td colspan="7" style="padding: 1em;">
													<table class="table" style="margin: 0;">
														<thead>
															<tr style="font-size: 0.9em;" class="tr-middle">
																<th colspan="7">Detalle de cajas</th>
															</tr>
															<tr style="font-size: 0.9em;" class="tr-middle">
																<th>Caja</th>
																<th>Venta</th>
																<th>Caja</th>
																<th>Depositos</th>
																<th>Cobro Tarjeta</th>
																<th>Venta al Crédito</th>
																<th>Diferencia</th>
															</tr>
														</thead>
														<tbody>
															<tr style="font-size: 0.9em;" class="tr-middle"
																*ngFor="let cash of day.warehousesDetail">
																<td>
																	{{cash.sucursal}}
																</td>
																<td>{{cash.venta | currency:'Q'}}</td>
																<td>{{cash.caja | currency:'Q'}}</td>
																<td>{{cash.depositos | currency:'Q'}}</td>
																<td>{{cash.cobroTarjeta | currency:'Q'}}</td>
																<td>{{cash.ventaCredito | currency:'Q'}}</td>
																<td>{{cash.diferencia | currency:'Q'}}</td>
															</tr>
														</tbody>
													</table>
												</td>
											</tr> -->
										</ng-container>
									</tbody>
								</table>
							</td>
						</tr>
						<tr class="tr-middle" *ngIf="showing['w'+general.warehouse] && general.transfers">
							<td colspan="8" style="padding: 1em; background-color: skyblue;">
								<table class="table">
									<thead>
										<tr>
											<th colspan="8" class="th-relative">
												<span class="h3"><i class="fa fa-handshake"></i>TRANSFERENCIAS</span>
												<div class="th-absolute-div">
													<i [ngClass]="general.showTransfers?'fa-eye-slash':'fa-eye'"
														class="fa clickeable text-info"
														(click)="general.showTransfers = !general.showTransfers"></i>
												</div>
											</th>
										</tr>
										<tr class="tr-middle" *ngIf="general.showTransfers">
											<th>Fecha</th>
											<th>Operación</th>
											<th>Caja</th>
											<th>Banco</th>
											<th>Monto</th>
											<th>Descripción</th>
											<th>Imagen</th>
										</tr>
									</thead>
									<tbody *ngIf="general.showTransfers">
										<ng-container *ngFor="let transfer of general.transfers">
											<tr class="tr-middle second-table">
												<td>{{transfer.dates}}</td>
												<td>{{transfer.document}}</td>
												<td>{{transfer.cashName}}</td>
												<td>{{transfer.bank}}</td>
												<td>{{transfer.amount | currency:'Q'}}</td>
												<td>{{transfer.description}}</td>
												<td>
													<section class="scrollport" *ngIf="transfer.image"
														style="justify-content: center !important;">
														<div (click)="transferSelected = transfer"
															style="background-image: url(https://s3.amazonaws.com/rrhh-images/cashClosure/transferBank/{{transfer.image}});">
															<div class="icon">
																<i class="fa fa-eye icon"></i>
															</div>
														</div>
													</section>
													<ng-container *ngIf="!transfer.image">
														<span style="opacity: 0.3; color: var(--bs-bg-servicios);">
															<i class="fa fa-circle-info"></i>
															<b>No se adjuntó imagen</b>
														</span>
														<br style="margin: 0;">
														<i tooltip="Haz click para hacer rollback"
															*ngIf="!rollbacking[transfer.id]"
															class="fa fa-rotate-right clickeable"
															(click)="rollback(transfer)"></i>
														<app-loading-animation *ngIf="rollbacking[transfer.id]"
															[height]="'1rem'"></app-loading-animation>
													</ng-container>
												</td>
											</tr>
										</ng-container>
									</tbody>
								</table>
							</td>
						</tr>
						<!-- <tr class="tr-middle" *ngIf="showing['w'+general.warehouse]">
							<td colspan="8" style="padding: 1em; background-color: skyblue;">
								<table class="table">
									<thead>
										<tr>
											<th colspan="8" class="th-relative">
												<span class="h3"><i class="fa fa-hand-holding-dollar"></i>CUENTAS POR
													COBRAR</span>
												<div class="th-absolute-div">
													<i [ngClass]="general.showAccountsReceivable?'fa-eye-slash':'fa-eye'"
														class="fa clickeable text-info"
														(click)="general.showAccountsReceivable = !general.showAccountsReceivable"></i>
												</div>
											</th>
										</tr>
										<tr class="tr-middle" *ngIf="general.showAccountsReceivable">
											<th>Fecha</th>
											<th>Operación</th>
											<th>Caja</th>
											<th>Banco</th>
											<th>Monto</th>
											<th>Descripción</th>
											<th>Imagen</th>
										</tr>
									</thead>
									<tbody *ngIf="general.showAccountsReceivable">
									</tbody>
								</table>
							</td>
						</tr> -->
					</ng-container>
					<tr class="tr-middle" *ngIf="data.length == 0 && got">
						<td colspan="7" style="font-size: 1.5em;">
							<i class="fa fa-circle-info"></i>No se encontraron resultados
						</td>
					</tr>
					<tr class="tr-middle" *ngIf="!got">
						<td colspan="7" style="padding: 2em;">
							<div class="d-flex align-items-center">
								<strong role="status">Cargando...</strong>
								<div class="spinner-border ms-auto" aria-hidden="true"></div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="table-responsive">
			<table class="table">
				<thead>
					<tr class="tr-middle">
						<th colspan="8" class="th-relative">
							<span class="h3"><i class="fa fa-hand-holding-dollar"></i>CUENTAS POR
								COBRAR</span>
							<span class="h3">
								<ng-container *ngIf="loadingCxcDownload">
									<i class="fa fa-floppy-disk"></i>
								</ng-container>
								<ng-container *ngIf="loadingCxcDownload">
									<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
									<span role="status"></span>
								</ng-container>
								<span tooltip="Descargar" *ngIf="!loadingCxcDownload"
									(click)="getCashClosuresAccountReport('excel')" class="clickeable text-info">
									<i class="fa fa-download"></i>
								</span>
							</span>
						</th>
					</tr>
					<tr class="tr-middle">
						<th>Fecha</th>
						<th>Cliente</th>
						<th>Tipo de Pago</th>
						<th>Bodega</th>
						<th>Detalles</th>
						<th>Monto</th>
						<th>Imagen</th>
						<th>Usuario</th>
						<th>Acciones</th>
					</tr>
				</thead>
				<tbody>
					<tr class="tr-middle" *ngFor="let account of accounts">
						<td>{{account.date | date: 'dd/MM/YYYY'}}</td>
						<td>
							<span>{{account.client.name}}</span>
							<br>
							<span style="font-size: 0.7rem; font-weight: bold;">NIT: {{account.client.nit}}</span>
						</td>
						<td>{{payments[account.type]}}</td>
						<td>{{account.warehouseName}}</td>
						<td>
							<ng-container *ngIf="account.type == 0">
								<span class="text-muted">--</span>
							</ng-container>
							<ng-container *ngIf="account.type == 1">
								<span>{{account.check.bank.name}}</span>
								<br>
								<span class="subtitle">Banco</span>
								<div class="row" *ngIf="moreDetails[account.id]">
									<div class="col">
										<span>{{account.check.number}}</span>
										<br>
										<span class="subtitle">Número</span>
									</div>
									<div class="col">
										<span>{{account.check.account}}</span>
										<br>
										<span class="subtitle">Cuenta</span>
									</div>
								</div>
								<ng-container *ngIf="moreDetails[account.id]">
									<span>{{account.check.date | date:'dd/MM/YYYY'}}</span>
									<br>
									<span class="subtitle">Fecha</span>
								</ng-container>
							</ng-container>
							<ng-container *ngIf="account.type == 2">
								<span>{{account.card.type.name}}</span>
								<br>
								<span class="subtitle">Tipo</span>
								<div class="row" *ngIf="moreDetails[account.id]">
									<div class="col">
										<span>{{account.card.reference}}</span>
										<br>
										<span class="subtitle">Referencia</span>
									</div>
									<div class="col">
										<span>{{account.card.authorization}}</span>
										<br>
										<span class="subtitle">Autorización</span>
									</div>
								</div>
							</ng-container>
							<ng-container *ngIf="account.type == 3">
								<span>{{account.transfer.account.alias}} -
									{{account.transfer.account.accountNumber}}</span>
								<br>
								<span class="subtitle">Cuenta</span>
								<div class="row" *ngIf="moreDetails[account.id]">
									<div class="col">
										<span>{{account.transfer.number}}</span>
										<br>
										<span class="subtitle">Número</span>
									</div>
									<div class="col">
										<span>{{account.transfer.advance | currency: 'Q'}}</span>
										<br>
										<span class="subtitle">Adelanto</span>
									</div>
								</div>
							</ng-container>
							<p *ngIf="account.type != 0" class="text-info clickeable"
								style="margin: 0; font-size: 0.7em;"
								(click)="moreDetails[account.id] = !moreDetails[account.id]">
								<i [ngClass]="moreDetails[account.id]?'fa-eye-slash':'fa-eye'" class="fa"></i>
								{{moreDetails[account.id]?'Ocultar detalles':'Ver más detalles'}}
							</p>
						</td>
						<td>{{account.amount | currency: 'Q'}}</td>
						<td>
							<span class="text-muted" style="opacity: 0.5; font-size: 0.7rem;" *ngIf="!account.image"><i
									class="fa fa-circle-info"></i>No se agregó imagen</span>
							<section class="scrollport" *ngIf="account.image"
								style="justify-content: center !important;">
								<div (click)="cashImage = 'https://s3.amazonaws.com/rrhh-images/cashClosure/cxc/'+account.image"
									style="background-image: url(https://s3.amazonaws.com/rrhh-images/cashClosure/cxc/{{account.image}});">
									<div class="icon">
										<i class="fa fa-eye icon"></i>
									</div>
								</div>
							</section>
						</td>
						<td>
							{{account.userName}}
						</td>
						<td class="ta">
							<span class="clickeable text-danger" (click)="deleteCashClosureAccount(account)">
								<i class="fa fa-trash"></i>
							</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<app-simple-pagination [elements]="paginationAccounts" [sizes]="sizes"
		(changed)="getAccounts()"></app-simple-pagination>
	</div>
</div>
<app-simple-modal [title]="'Foto'" [requiredFields]="false" [max]="90" *ngIf="cashImage" (close)="cashImage = null">
	<div fields>
		<div style="display: flex; justify-content: center;">
			<img src="{{cashImage}}" alt="">
		</div>
	</div>
</app-simple-modal>
<app-simple-modal [title]="'Eliminar cierre de caja'" [requiredFields]="false" [max]="90" *ngIf="cashToDelete"
	(close)="cashToDelete = null">
	<div fields>
		<h5 style="text-align: center;" class="text-info"><i class="fa fa-circle-info"></i> Se eliminará el siguiente
			cierre de caja</h5>
		<table class="table">
			<thead>
				<tr class="tr-middle">
					<th>Día</th>
					<th>Venta</th>
					<th>Caja</th>
					<th>Depositos</th>
					<th>Cobro Tarjeta</th>
					<th>Venta al Crédito</th>
					<th>Gastos</th>
					<th>Diferencia</th>
				</tr>
			</thead>
			<tbody>
				<tr class="tr-middle">
					<td>
						{{cashToDelete.day}}
					</td>
					<td>{{cashToDelete.sale | currency:'Q'}}</td>
					<td>{{cashToDelete.cash | currency:'Q'}}</td>
					<td>{{cashToDelete.transfer | currency:'Q'}}</td>
					<td>{{cashToDelete.target | currency:'Q'}}</td>
					<td>{{cashToDelete.checkData | currency:'Q'}}</td>
					<td>{{cashToDelete.expenseTotal | currency:'Q'}}</td>
					<td>{{cashToDelete.difference | currency:'Q'}}</td>
				</tr>
			</tbody>
		</table>
		<!-- Checkbox para notificar -->
		<div class="form-check mt-3">
			<input 
				type="checkbox" 
				class="form-check-input" 
				id="notifyCheckbox" 
				[(ngModel)]="notifyOnDelete">
			<label class="form-check-label" for="notifyCheckbox">
				Se notificará sobre esta eliminación
			</label>
		</div>
	</div>
	<div buttons>
		<app-loading-button [logo]="true" [object]="buttonConfirmDelete"
			(clicked)="deleteCashClosure()"></app-loading-button>
	</div>
</app-simple-modal>
<app-simple-modal [title]="'Foto'" [requiredFields]="false" [max]="90" *ngIf="transferSelected"
	(close)="closeModalTransfer()">
	<div fields>
		<div class="row">
			<div class="col-sm-4">
				<div class="form-group">
					<label for="fecha" class="form-label">Fecha</label>
					<input type="date" disabled [value]="transferSelected.dates" class="form-control">
				</div>
				<div class="form-group">
					<label for="operacion" class="form-label">Operacion</label>
					<input type="text" disabled [value]="transferSelected.document" class="form-control">
				</div>
				<div class="form-group">
					<label for="cuenta" class="form-label">Caja</label>
					<input type="text" disabled [value]="transferSelected.cashName" class="form-control">
				</div>
				<div class="form-group">
					<label for="banco" class="form-label">Banco</label>
					<input type="text" disabled [value]="transferSelected.bank" class="form-control">
				</div>
				<div class="form-group">
					<label for="monto" class="form-label">Monto</label>
					<input type="text" disabled [value]="transferSelected.amount" class="form-control">
				</div>
				<div class="form-group">
					<label for="descripcion" class="form-label">Descripción</label>
					<textarea type="text" disabled [value]="transferSelected.description"
						class="form-control"></textarea>
				</div>
				<div class="form-group">
					<label for="options" class="form-label">Opciones</label>
					<div class="button-closure">
						<app-loading-button [object]="buttonRollback"
							(clicked)="rollback(transferSelected)"></app-loading-button>
						<!-- <button class="btn btn-success">
							<i class="fa fa-circle-check"></i>ACEPTAR
						</button> -->
					</div>
				</div>
			</div>
			<div class="col-sm-8" style="display: flex; align-items: center; justify-content: center;">
				<img src="https://s3.amazonaws.com/rrhh-images/cashClosure/transferBank/{{transferSelected.image}}"
					alt="">
			</div>
		</div>
	</div>
</app-simple-modal>